import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import { FieldArray, useFormikContext } from 'formik';

import {
  TextField,
  TextFieldWithAddon,
} from 'ui/FormElement';

export default function ActivationFee({
  isReadonly,
  mark,
}) {
  const {
    values: { onetime_custom_records: oneTimeCustomRecords, activation_fee: activationFee, is_free },
  } = useFormikContext();

  const isItemPresent = oneTimeCustomRecords.some((item) => item.is_activation_fee);

  const onRemove = (remove) => {
    oneTimeCustomRecords.forEach((item, index) => {
      if (item.is_activation_fee) {
        remove(index);
      }
    });
  };

  const onAdd = (push) => {
    push({
      name: activationFee.name,
      price: activationFee.price,
      is_activation_fee: true,
    });
  };

  if (activationFee == null) {
    return (
      <>
        <h3>Activation Fee</h3>
        <div>Plan has no Activation Fee.</div>
      </>
    );
  }

  return (
    <div>
      <h3>Activation Fee</h3>
      <FieldArray name="onetime_custom_records">
        {({ remove, push }) => (
          <div>
            {oneTimeCustomRecords.map(
              (customRecord, index) => {
                if (!customRecord.is_activation_fee) {
                  return <div />;
                }
                return (
                  <Row>
                    <Col md={4}>
                      <TextField
                        name={`onetime_custom_records.${index}.name`}
                        placeholder="Set Name"
                        disabled
                      />
                    </Col>
                    <Col md={4}>
                      <TextFieldWithAddon
                        name={`onetime_custom_records.${index}.price`}
                        type="number"
                        addon={mark}
                        placeholder="Set Price"
                        disabled
                        min="0"
                        step="0.01"
                        pattern="d+(.d{1,2})?"
                      />
                    </Col>
                    {!isReadonly && isItemPresent && (
                      <Col md={4}>
                        <Button bsStyle="danger" onClick={() => onRemove(remove)}>Remove</Button>
                      </Col>
                    )}
                  </Row>
                );
              },
            )}
            {!isReadonly && (
              <>
                {!isItemPresent && !is_free && (
                  <Button bsStyle="primary" onClick={() => onAdd(push)}>Add</Button>
                )}
              </>
            )}
          </div>
        )}
      </FieldArray>
    </div>

  );
}

ActivationFee.propTypes = {
  isReadonly: PropTypes.bool,
};

ActivationFee.defaultProps = {
  isReadonly: true,
};
